$(document).ready(function()
{
    
    function finalCheckout()
    {
        var currentCartItems = {};

        var maxEclecticDeliveryCost = parseFloat($('#eclecticMaxDelivery').html());
        var maxEpionceDeliveryCost = parseFloat($('#epionceMaxDelivery').html());

        var eclecticDeliveryCost = 0;
        var epionceDeliveryCost = 0;

        updateFinalCheckout();

        function updateFinalCheckout()
        {

            currentCartItemsJSON = localStorage.getItem('currentCartItems');

            if (currentCartItems)
            {
                currentCartItems =  JSON.parse(currentCartItemsJSON);
            }
            else
            {
                currentCartItems = {};
            }

            currentCartPrice = 0.00;
            eclecticDeliveryCost = 0;
            epionceDeliveryCost = 0;
            totalDeliveryCost = 0.00;
            finalTotalCosts = 0.00;
            hasSplitDelivery = false;
            hasEpionceDelivery = false;
            hasEclecticDelivery = false;
            totalUnits = 0;

            simpleTextOutput = "Summary:\n";

            var lines = 0;

            for (var key in currentCartItems)
            {
                var line = currentCartItems[key];
                if (line.is_epionce && line.is_epionce != 0) 
                {
                  updateEpionceDeliveryCharge();
                }
                else
                {
                  updateEclecticDeliveryCharge(line.delivery_charge, line.qty);
                }
                totalUnits += line.qty;
                simpleTextOutput += "\n" + key + ": " + line.title  + " @ £" + line.final_price.toFixed(2) + " x " + line.qty;  

                var line_subtotal = parseFloat(line.final_price * line.qty); 
                currentCartPrice += line_subtotal;
                lines++;

            }

            finalTotalCosts = currentCartPrice + totalDeliveryCost;
            

            $(".finalBasketCost input.gform_hidden").val(finalTotalCosts.toFixed(2));
            $(".finalBasketCost span.ginput_total").html(SharedUtils.currencyFormat(finalTotalCosts));

            $(".finalBasketItems textarea").val(currentCartItemsJSON); 
            $(".finalBasketItemsPlainText textarea").val(simpleTextOutput); 

            $(".basketTotal input.ginput_amount").val(currentCartPrice.toFixed(2));

            $(".basketShipping input.gform_hidden").val(totalDeliveryCost.toFixed(2));
            $(".basketShipping span.ginput_shipping_price").html(SharedUtils.currencyFormat(totalDeliveryCost));

            if (finalTotalCosts > SharedConfig.maximumBasketValue || totalUnits > SharedConfig.maximumBasketUnits )
            {
                $('#showTheCart').slideUp();
                $('#hideTheCart').slideUp();
                var warningMsg = '';
                if (finalTotalCosts > SharedConfig.maximumBasketValue)
                {
                    warningMsg = "The maximum value permitted for a transaction is " + SharedUtils.maxBasketValueStr() + ". Please return to your basket and remove some items.";
                }
                else
                {
                    warningMsg = "The maximum number of products you can purchase in a single transaction is " + SharedConfig.maximumBasketUnits + ". Please return to your basket and remove some items.";
                }

                $('#maxValuesWarning .warningMsg').html(warningMsg);
                $('#maxValuesWarning').slideDown();
            }

            else if(lines == 0)
            {
              $('#hideTheCart').slideDown();
              $('#showTheCart').slideUp();
              $('#maxValuesWarning').slideUp();
            }
            else
            {
              $('#hideTheCart').slideUp();
              $('#showTheCart').slideDown();    
              $('#maxValuesWarning').slideUp();        
            }

        }





        function updateEpionceDeliveryCharge()
        {
          hasEpionceDelivery = true;    
          if (epionceDeliveryCost == 0)
          {
            epionceDeliveryCost = maxEpionceDeliveryCost;
            if (hasEclecticDelivery && hasEpionceDelivery)
            {
              hasSplitDelivery = true;
            }
          }

          totalDeliveryCost = epionceDeliveryCost + eclecticDeliveryCost;
          return true;
        }

        function updateEclecticDeliveryCharge(cost, qty)
        {
          var add_me = cost * qty;
          var new_total = eclecticDeliveryCost + add_me;
          hasEclecticDelivery = true;

          if (new_total > maxEclecticDeliveryCost)
          {
            eclecticDeliveryCost = maxEclecticDeliveryCost;
          }
          else
          {
            eclecticDeliveryCost = new_total;
          }

          if (hasEclecticDelivery && hasEpionceDelivery)
          {
            hasSplitDelivery = true;
          }
          else
          {   
            hasSplitDelivery = false;
          }   

          totalDeliveryCost = epionceDeliveryCost + eclecticDeliveryCost;

          return true;
        }

    };

    if ( $('#finalCheckout').length )
    {
      setTimeout(function() 
      {
          finalCheckout();
      }
      , 1000);
    }


});